/**
 * @flow
 */
class Session {

  get lastCompanyId() { return this.get('@lastCompanyId'); }
  set lastCompanyId(id) { this.set('@lastCompanyId', id); }

  get lastBranchId() { return this.get('@lastBranchId'); }
  set lastBranchId(id) { this.set('@lastBranchId', id); }

  constructor() {
    process.env.NODE_ENV !== 'production' && console.log('[Session Storage] initialized.');
  }

  get(key: string): string | number | Object | null {
    try {
      const res = sessionStorage.getItem(key);
      return res ? JSON.parse(res) : null;
    } catch(error) {
      console.log(error);
      return null;
    }
  }

  set(key: string, data: Object | null) {
    if(data === null) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, JSON.stringify(data));
    }
  }

  unset(key: string) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }

}

export default new Session();
